import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import InputField from "../../InputField";
import exportImage from "../../../asset/Images";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import Alert from "../../../component/Alert";

export default function ProjectAdd() {
  const storedBranchArray =
    JSON.parse(sessionStorage.getItem("branchNames")) || [];

  const [selectBranch, setSelectedBranch] = useState(null);
  const { state } = useLocation();
  const [postAlert, setPostAlert] = useState();
  const [putAlert, setPutAlert] = useState();
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      formValue: [
        {
          item: "",
          description: "",
          qty: "",
          price: "",
          total: "",
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    name: "formValue",
    control,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const { formValue, paymentSplitting, descriptionCount } = watch();

  const descriptionOtherArray = Array.from(
    { length: descriptionCount },
    (_, i) => {
      return i + 1;
    }
  );
  const paymentSplittingArray = Array.from(
    { length: Number(paymentSplitting) },
    (_, i) => {
      return i + 1;
    }
  );

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/quotation/${selectBranch}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error; // Rethrow to trigger onError
      }
    },
    {
      onSuccess: () => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add quotation",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to add quotation. Please try again.");
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/quotation/${selectBranch}/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating quotation:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setIsModalOpen(true);
        setPopupType({
          ...popupType,
          type: "add quotation",
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the quotation. Please try again.");
      },
    }
  );

  const onSubmit = (data) => {
    console.log("formData", data);
    setPostAlert(data);
  };

  return (
    <>
      <div className="screen_mainContainer">
        <div className="screen_InnerContainer">
          <header className="screen_headerContainer">
            <div className="header_title">Add Project</div>
            <div className="header_branchSelect_container">
              <Controller
                name="branchSelect"
                control={control}
                rules={{ required: "Branch selection is required" }}
                render={({ field }) => (
                  <select
                    {...field}
                    className="branchSelect"
                    onChange={(e) => {
                      field.onChange(e); // Update form state
                      setSelectedBranch(e.target.value); // Update local state
                    }}
                    value={field.value || ""}
                  >
                    <option value="">-Select Branch-</option>
                    {storedBranchArray.map((branch, index) => (
                      <option key={index} value={branch}>
                        {branch}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors.branchSelect && (
                <p style={{ color: "red" }}>{errors.branchSelect.message}</p>
              )}
            </div>
          </header>
          <section className="py-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form_OverAllContainer">
                <div className="commonForm_container">
                  <div className="input_container">
                    <label className="inputLabel">Branch</label>
                    <Controller
                      control={control}
                      name="branch"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Date</label>
                    <Controller
                      control={control}
                      name="quotationDate"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="date"
                          commonInputCss="commonInputCss"
                          // placeholder="DD/MM/YYYY"
                        />
                        // <DateField {...field} commonInputCss="commonInputCss" />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">GST In</label>
                    <Controller
                      control={control}
                      name="gstIn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">
                      Project for Customer Name
                    </label>
                    <Controller
                      control={control}
                      name="projectCustomerName"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Street</label>
                    <Controller
                      control={control}
                      name="street"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Locality</label>
                    <Controller
                      control={control}
                      name="locality"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">City</label>
                    <Controller
                      control={control}
                      name="city"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">State</label>
                    <Controller
                      control={control}
                      name="state"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Pincode</label>
                    <Controller
                      control={control}
                      name="pincode"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Nature of Business</label>
                    <Controller
                      control={control}
                      name="natureOfBusiness"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Site Address</label>
                    <Controller
                      control={control}
                      name="siteAddress"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Kind Attn</label>
                    <Controller
                      control={control}
                      name="kindAttn"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>

                  <div className="proposalInput_container">
                    <label className="inputLabel">Proposal</label>
                    <Controller
                      control={control}
                      name="proposal"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="text"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                  <div className="input_container">
                    <label className="inputLabel">Site Visit Date</label>
                    <Controller
                      control={control}
                      name="siteVisitDate"
                      render={(field) => (
                        <InputField
                          {...field}
                          type="date"
                          commonInputCss="commonInputCss"
                        />
                      )}
                    />
                  </div>
                </div>

                {fields?.map((item, index) => {
                  const totalAmt =
                    formValue[index]?.qty * formValue[index]?.price;

                  return (
                    <div key={item.id} className="appendForm_container">
                      <div className="ItemInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Item</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.item`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="descriptionInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Description</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.description`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">QTY</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.qty`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Price</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.price`}
                          render={(field) => (
                            <InputField
                              {...field}
                              type="text"
                              commonInputCss="commonInputCss"
                            />
                          )}
                        />
                      </div>
                      <div className="qtyInput_container ">
                        {index === 0 && (
                          <label className="inputLabel">Total</label>
                        )}
                        <Controller
                          control={control}
                          name={`formValue.${index}.total`}
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <input
                              onChange={onChange}
                              value={totalAmt ? totalAmt : ""}
                              className="commonInputCss"
                            />

                            // <InputField
                            //   {...field}
                            //   type="text"
                            //   commonInputCss="commonInputCss"
                            // />
                          )}
                        />
                      </div>
                      <div className="appendBtnContainer">
                        <div
                          className="appendBtn"
                          onClick={() => {
                            append();
                          }}
                        >
                          <img
                            className="mb-1"
                            src={exportImage?.addIcon}
                            alt="addIcon"
                          />
                        </div>
                        {index !== 0 && (
                          <div
                            className="appendBtn"
                            onClick={() => {
                              remove(index);
                            }}
                          >
                            <img
                              className="mb-1"
                              src={exportImage?.deleteIcon}
                              alt="deleteIcon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}

                <div className="SpecificationsForm_container">
                  <div className="SpecificationsInput_container ">
                    <label className="inputLabel">Ms Materials</label>
                    <Controller
                      control={control}
                      name="msMaterials"
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <textarea
                          onChange={onChange}
                          value={value}
                          className="commonInputCss h-75"
                        ></textarea>
                      )}
                    />
                  </div>

                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Discount</label>
                      <Controller
                        control={control}
                        name="discount"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Start Date</label>
                      <Controller
                        control={control}
                        name="startDate"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="date"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">End Date</label>
                      <Controller
                        control={control}
                        name="endDate"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="date"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>

                  <div>
                    <div className="commonForm_container">
                      <div className="input_container">
                        <label className="inputLabel">Payment splitting</label>
                        <Controller
                          control={control}
                          name="paymentSplitting"
                          render={({
                            field: { onChange, onBlur, value, ref },
                          }) => (
                            <select
                              onChange={onChange}
                              value={value}
                              className="commonInputCss"
                            >
                              <option value=""> --Select-- </option>
                              <option value="1"> Single </option>
                              <option value="2"> Double </option>
                              <option value="3"> Triple </option>
                              <option value="4"> Fourth </option>
                              <option value="other"> Manual Splitting </option>
                            </select>
                          )}
                        />
                      </div>
                      {/* {paymentSplitting === "other" && (
                        <div className="qtyInput_container">
                          <label className="inputLabel"> </label>
                          <Controller
                            control={control}
                            name="descriptionCount"
                            render={(field) => (
                              <InputField
                                {...field}
                                type="type"
                                commonInputCss="commonInputCss"
                              />
                            )}
                          />
                        </div>
                      )} */}
                    </div>
                  </div>

                  {/* <div className="descriptionSpiltContainer">
                    {(paymentSplitting === "other"
                      ? descriptionOtherArray
                      : paymentSplittingArray
                    )?.map((index) => {
                      return (
                        <div className="descriptionSpiltCss">
                          <div className=" w-50">
                            <Controller
                              control={control}
                              name={`descriptionCount${index}`}
                              render={(field) => (
                                <InputField
                                  {...field}
                                  type="number"
                                  placeholder="0.00"
                                  commonInputCss="commonInputCss"
                                />
                              )}
                            />
                          </div>
                          <div className=" w-75 text-center">
                            <Controller
                              control={control}
                              name={`descriptionSpilt${index}`}
                              render={(field) => (
                                <InputField
                                  {...field}
                                  type="text"
                                  placeholder={`Description Spilt ${index}`}
                                  commonInputCss="commonInputCss"
                                />
                              )}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div> */}

                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Category</label>
                      <Controller
                        control={control}
                        name="category"
                        render={({
                          field: { onChange, onBlur, value, ref },
                        }) => (
                          <select
                            onChange={onChange}
                            value={value}
                            className="commonInputCss"
                          >
                            <option value=""> --Select-- </option>
                            <option value="Test Demo"> Test Demo </option>
                            <option value="Test Demo"> Test Demo </option>
                            <option value="Test Demo"> Test Demo </option>
                          </select>
                        )}
                      />
                    </div>
                  </div>

                  <div className="commonForm_container">
                    <div className="proposalInput_container">
                      <label className="inputLabel">Terms & Condition</label>
                      <div className="termsConditionCss">
                        1. As per Final Drawing, Materials will supply within 7
                        to 10 days from the date of Receipt of the written work
                        order or signed copy along with the advance. (Supplied
                        material will kept in designated area near to Lift shaft
                        under customer custody) unloading our scope. <br />
                        2. Fabrication work will be completed within 20 to 25
                        days & electrical work 4 to 7 days to be agreed up on by
                        either side and based on the site front availability &
                        Lift vendor coordination (RCC Lift pit, Major & Minor
                        Builders Civil / Touch up work – customer Scope). <br />
                        3.Rigid Metal Scaffolding (inner sides) with work
                        platform, Electricity for using Tools, Lighting
                        illumination & safe storing place will be in your scope,
                        free of cost to us. Land scapping work will get disturb
                        due to welding work & need to re- do, Side walls near
                        lift shaft need to repaint & flooring below Lift area
                        will get Broken while removal for which SLBC cannot be
                        held responsible. <br />
                        4. Extra work (on the job time requirement) which need
                        to complete the lift, required by Maintenance Dept. &
                        any other vendor will charge additionally based on the
                        Customer approval. <br />
                        5. Timely completion depends on timely receipt payment.
                        Any delay in payment (for the agreed & additional work
                        requested later) will lead to delay in delivery / work
                        dates for which SLBC cannot be held responsible <br />
                        6. Extra SGST - 9% & CGST - 9% is applicable for Every
                        RA Bill & Our GST No. Is 33AEHFS9909K1ZH, (you can avail
                        ITC Benefit from our Invoice). <br />
                        7. Customer PO & Advance will treat as Work order for
                        proceeding our work. <br />
                        8. Please find our Bank Details - Acc. Name: M/s. Sri
                        Lakshmi Build craft, Acc.No: 7531 0200 001413, Bank of
                        Baroda, Indira Nagar Branch, Current Account and Ifsc
                        code BARB0VJINNG. <br />
                        9.Estimated ( Kgs & SqFt +/ - 10% only ) Weigh Bridge
                        Slip / supplied material inward Bill will be Taken for
                        calculating weight & Rates coated are inclusive of cost
                        of materials, tools, tackles, Labor, transport ,
                        Fittings, Holes, Fischer Anchor bolts, Foundation bolts,
                        loading & unloading at site charges, painting ,Wastages,
                        & over laps etc., to complete as per lift Vendor Shaft
                        drawing GAD.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="billDetails_container">
                  <header className="header_title">Bill Details</header>
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">Name</label>
                      <Controller
                        control={control}
                        name="BillName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">No</label>
                      <Controller
                        control={control}
                        name="BillNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Street</label>
                      <Controller
                        control={control}
                        name="billStreet"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Locality</label>
                      <Controller
                        control={control}
                        name="billLocality"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">City</label>
                      <Controller
                        control={control}
                        name="billCity"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Pin code</label>
                      <Controller
                        control={control}
                        name="billPinCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Phone Number</label>
                      <Controller
                        control={control}
                        name="billPhoneNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Alter Number</label>
                      <Controller
                        control={control}
                        name="billAlterNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">GST In</label>
                      <Controller
                        control={control}
                        name="billGstIn"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>

                <div className="bankDetails_container">
                  <header className="header_title">Branch Details</header>
                  <div className="commonForm_container">
                    <div className="input_container">
                      <label className="inputLabel">
                        Current Acc Holder Name
                      </label>
                      <Controller
                        control={control}
                        name="currentAccHolderName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Bank Name</label>
                      <Controller
                        control={control}
                        name="bankName"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">A/C No</label>
                      <Controller
                        control={control}
                        name="acNo"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">IFSC Code</label>
                      <Controller
                        control={control}
                        name="ifscCode"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Branch</label>
                      <Controller
                        control={control}
                        name="Branch"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                    <div className="input_container">
                      <label className="inputLabel">Phone number</label>
                      <Controller
                        control={control}
                        name="bankPhoneNumber"
                        render={(field) => (
                          <InputField
                            {...field}
                            type="text"
                            commonInputCss="commonInputCss"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="submitBtnContainer">
                <button className="submitBtn" type="submit">
                  Add Project
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Alert
        open={postAlert}
        setPutAlert={setPutAlert}
        postAlert={postAlert}
        // state={state}
        // upData={upData}
        putAlert={putAlert}
        mutate={mutate}
        navigates="/"
        // id={state?.id}
        add={true}
        onCloses={setPostAlert}
        // setPutAlert={setPutAlert}
      />
    </>
  );
}
